import React from 'react';

interface CloseButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  ariaLabel = 'Fechar',
  style,
  className,
  type = 'button',
  ...restProps
}) => (
  <button
    type={type}
    aria-label={ariaLabel}
    className={className ? `btn-close ${className}` : 'btn-close'}
    style={{ ...style }}
    {...restProps}
  />
);

export default CloseButton;
